import React from "react";
import {
  TextField
} from "@mui/material";
import ModalSensorFilter from "../ModalSensorFilter";
import agent from "../../agent/agent";

const FilterSensors = ({ value, name, contractId, onChange }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [devices, setDevices] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const loadedForContract = React.useRef(null);

  // Предзагрузка при монтировании / смене контракта
  React.useEffect(() => {
    if (!contractId || loadedForContract.current === contractId) return;
    loadedForContract.current = contractId;
    setIsLoading(true);
    agent.get(`/filters/${contractId}`)
      .then((res) => {
        if (res?.data?.data?.validation_rules?.missing_sensor === false) {
          return res.data?.data?.devices || [];
        }
        return (res.data?.data?.devices || []).filter((t) => t.is_selected);
      })
      .catch(() => [])
      .then((result) => {
        setDevices(result);
        setIsLoading(false);
      });
  }, [contractId]);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleChange = (newValue) => {
    onChange({ target: { name, value: newValue } });
  };

  return (
    <>
      <TextField
        value={value.length > 0 ? `Выбрано ${value.length} устройств` : ""}
        fullWidth
        label="Устройство"
        className="--floating-label"
        variant="outlined"
        onClick={handleOpen}
        InputProps={{ readOnly: true }}
        sx={{ "& .MuiOutlinedInput-root": { height: 44 } }}
      />

      <ModalSensorFilter
        value={value}
        isOpen={isOpen}
        items={devices}
        isLoading={isLoading}
        onClose={handleClose}
        onChange={handleChange}
      />
    </>
  );
};

export default FilterSensors;
